export enum CheckListLevel {
  LOADING_POINT = "LOADING_POINT",
  WORK_POINT = "WORK_POINT",
  UNLOADING_POINT = "UNLOADING_POINT",

  // 인수증
  RECEIPT = "RECEIPT",
}

export const getCheckImageType = async (
  currentLevel: number
): Promise<CheckListLevel> => {
  if (currentLevel === 1 || currentLevel === 2) {
    return CheckListLevel.LOADING_POINT;
  } else if (currentLevel === 3 || currentLevel === 4) {
    return CheckListLevel.WORK_POINT;
  } else if (currentLevel === 5 || currentLevel === 6) {
    return CheckListLevel.UNLOADING_POINT;
  }
  return CheckListLevel.LOADING_POINT; // 기본값 반환
};
